import { ControlInterface } from 'edocatbase/Form';
import { isEmpty } from 'ramda';
import { hasValueChanged, defineValueToSend, getValue } from '../../../lib/authority';
import Value from './Value';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getNamesByNodes } from '../../../actions/form';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import Select from '../../../../Select/Authority';

interface AuthorityInterface extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
	helperText: string;
	important: any;
	docgenform?: boolean | undefined;
}
class Authority extends window.React.PureComponent<AuthorityInterface> {
	static defaultProps = {
		excludedOptions: [],
		disableNodeRef: [],
	};

	updateValue = () => {
		const { actions, name, value, defaultValue, formInstanceId, innerFormInstanceId, docgenform, onChange } = this.props;

		if(docgenform && ["currentUser", "superior"].includes(value)){
			onChange([name], {
				label: value,
				value: value
			}, true);
		} else {
			if (value && !isEmpty(value) && !value[0].displayName) {
				if (value === 'currentUser' || value[0] === 'currentUser') {
					const currentUser = window.Alfresco.constants.CURRENT_USER;
					const currentUserValue = {
						value: currentUser.nodeRef,
						label: `${currentUser.firstName} ${currentUser.lastName} (${currentUser.userName})`,
						type: 'USER',
					};
					actions.getNamesByNodes(
						formInstanceId,
						name,
						defineValueToSend(currentUserValue, defaultValue),
						innerFormInstanceId
					);
				} else if (value === 'superior' || value[0] === 'superior') {
					const currentUser = window.Alfresco.constants.CURRENT_USER;
					const currentUserSuperiorValue = {
						value: currentUser.superior?.nodeRef,
						label: `${currentUser.superior?.firstName} ${currentUser.superior?.lastName} (${currentUser.superior?.userName})`,
						type: 'USER',
					};
					actions.getNamesByNodes(
						formInstanceId,
						name,
						defineValueToSend(currentUserSuperiorValue, defaultValue),
						innerFormInstanceId
					);
				} else {
					const values = typeof value === "string" ? value : Array.from(new Set(value));
					actions.getNamesByNodes(formInstanceId, name, defineValueToSend(values, defaultValue), innerFormInstanceId);
				}
			}
		}
	};

	componentDidMount() {
		this.updateValue();
	}

	async componentDidUpdate(prevProps: any) {
		if (
			this.props.value &&
			((Array.isArray(this.props.value) && this.props.value.some(item => !item.hasOwnProperty('value'))) ||
				(!Array.isArray(this.props.value) && !this.props.value.hasOwnProperty('value'))) &&
			hasValueChanged(this.props.value, prevProps.value)
		) {
			await this.updateValue();
		}
	}

	onSelectChange = (value: any) => {
		const { name, onChange } = this.props;
		onChange([name], value, true);
	};

	render() {
		const {
			autoFocus,
			disabled,
			value,
			label,
			repeating,
			dataType,
			control: {
				params: { allowSystem, parentAuthority, root, disableExternalGroups, disableExternalUsers, disableNodeRef },
			},
			className,
			error,
			excludedOptions,
			mandatory,
			name,
			placeholder,
			readOnly,
			helperText,
			important,
			docgenform,
		} = this.props;

		const wfExcludedOptions = window.__HEADER_INITIAL_DATA__?.wfExcludedOptions.split(",");
		// m2c resolve
		const excludedOpt = (name === 'assoc_aspISO_authorityAssignees' || name === 'assoc_wfST_authorityAssignees') && wfExcludedOptions ? wfExcludedOptions : excludedOptions;

		return readOnly ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<Value value={value} />
			</div>
		) : disabled ? (
			<div className={`form-row row-${name} read-only-row`}>
				<label>{label}</label>
				<Value value={value} />
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<Select
					id={name}
					allowSystem={allowSystem}
					disableExternalGroups={disableExternalGroups}
					disableExternalUsers={disableExternalUsers}
					autoFocus={autoFocus}
					className={className}
					disabled={disabled || (docgenform && ["currentUser", "superior"].includes(value?.value))} //disabled Authority select
					error={error}
					excludedOptions={excludedOpt}
					disableNodeRef={disableNodeRef}
					isClearable={true}
					label={label}
					mandatory={mandatory}
					multi={repeating}
					name={name}
					onChange={this.onSelectChange}
					parentAuthority={parentAuthority}
					placeholder={placeholder}
					type={dataType}
					value={getValue(value, repeating)}
					helperText={helperText}
					important={important}
					root={root}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: AuthorityInterface) => {
	const fieldNames = state[props.formInstanceId].form.fields[props.name]?.excludedOptionsFieldName;
	let selectedInOther: any = [];
	const excludedOptions = state[props.formInstanceId].form.fields[props.name]?.excludedOptions || [];
	fieldNames
		? fieldNames.forEach((item: any) =>
				Array.isArray(state[props.formInstanceId].form.fields[item]?.value)
					? state[props.formInstanceId].form.fields[item]?.value.forEach((item: any) =>
							selectedInOther.push(item.value)
					  )
					: selectedInOther.push(state[props.formInstanceId].form.fields[item]?.value?.value)
		  )
		: '';

	return {
		excludedOptions: selectedInOther,
		disableNodeRef: [...excludedOptions],
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ getNamesByNodes }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Authority);
